{
  "login": {
    "title": "Sign In",
    "username": "Username",
    "password": "Password",
    "button": "Log In",
    "error": "Invalid username or password",
    "usernameRequired": "Username is required",
    "passwordRequired": "Password is required",
    "submit": "Sign In"
  },
  "dashboard": {
    "welcome": "Welcome, {{name}}!",
    "loading": "Loading data..."
  }
}
